module.exports = __webpack_public_path__ + "static/img/rest12.9cb539d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest12.jpg
// module id = kdiM
// module chunks = 0